import { render, staticRenderFns } from "./Totp.vue?vue&type=template&id=c1394030&scoped=true&"
import script from "./Totp.vue?vue&type=script&lang=ts&"
export * from "./Totp.vue?vue&type=script&lang=ts&"
import style0 from "./Totp.vue?vue&type=style&index=0&id=c1394030&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1394030",
  null
  
)

export default component.exports